
import { Options, prop, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";

export interface PickupStatusConfig {
  label: string;
  className: string;
}

class Props {
  statusCode = prop<string>({
    required: true
  });
}

@Options({
  name: "PickupStatusBadge"
})
export default class PickupStatusBadge extends Vue.with(Props) {
  get statusConfig(): PickupStatusConfig {
    return this.mapPickupStatusBadge(this.statusCode);
  }

  mapPickupStatusBadge(statusCode: string): PickupStatusConfig {
    const code = (statusCode || "").toUpperCase();

    switch (code) {
      case "SHPCRT":
        return {
          label: this.isMalaysia ? "Shipment Created" : "Pengiriman Dibuat",
          className: "bg-gray-lp-200 text-black-lp-300"
        };
      case "CRRSRC":
        return {
          label: this.isMalaysia ? "Search for Courier" : "Menunggu Kurir",
          className: "bg-gray-lp-200 text-black-lp-300"
        };
      case "CRRNFD":
      case "CRROTW":
      case "SHPSCD":
        return {
          label: this.$t("pickup.detail.status.waitingCourier") as string,
          className: "bg-gray-lp-200 text-black-lp-300"
        };
      case "CRRPIC":
        return {
          label: this.$t("pickup.detail.status.pickUpPackage") as string,
          className: "bg-blue-lp-200 text-blue-lp-300"
        };
      case "SHPMRG":
        return {
          label: this.$t("pickup.detail.status.mergedPickUp") as string,
          className: "bg-red-300 text-red-lp-200"
        };
      case "CRRCNC":
      case "CSTCNC":
      case "ADMCNC":
        return {
          label: this.$t("pickup.detail.status.cancelled") as string,
          className: "bg-red-lp-3000 text-red-lp-2400"
        };
      case "CRRDON":
      case "SHPDON":
        return {
          label: this.$t("pickup.detail.status.done") as string,
          className: "bg-green-lp-300 text-green-lp-200"
        };
      default:
        return { label: code, className: "bg-gray-lp-200 text-black-lp-300" };
    }
  }

  get isMalaysia(): boolean {
    return AccountController.accountData.countryCode?.toUpperCase() === "MY";
  }
}
